// extracted by mini-css-extract-plugin
export var colorOrange = "style-module--color-orange--56c45";
export var colorViolet = "style-module--color-violet--703c7";
export var listMain = "style-module--list-main--433af";
export var strategist = "style-module--strategist--8fa55";
export var tactic = "style-module--tactic--dd0f5";
export var who = "style-module--who--1bdef";